import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.setCanonicalUrl(`https://dart-rock-cafe.de${event.urlAfterRedirects}`);
    });
  }

  setCanonicalUrl(url: string) {
    let link: HTMLLinkElement = this.document.querySelector("link[rel='canonical']") || this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);

    if (!this.document.querySelector("link[rel='canonical']")) {
      this.document.head.appendChild(link);
    }
  }
}
